import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import { InAppBrowser } from '@ionic-native/in-app-browser';

import * as moment from "moment";
import {NewsReadPage} from "../news-read/news-read";
import {DataProvider} from "../../providers/data";

import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';

import { FileOpener } from '@ionic-native/file-opener';

import { LoadingProvider } from '../../providers/loading';


/**
 * Generated class for the EventsDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-events-details',
  templateUrl: 'events-details.html',
})
export class EventsDetailsPage {

  image_url: string = 'https://app.fw-wesling.de/uploads/events';
  pdf_path: string = 'https://app.fw-wesling.de/uploads/events/';
  details: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider, private iab: InAppBrowser, private transfer: FileTransfer, private file: File, private fileOpener: FileOpener, public loadingProvider: LoadingProvider) {
    this.details = this.navParams.get("details");
  }

  setEventState(state: number) {
    this.teamappProvider.http_request('action=set_event_state&event_state='+state+'&event_id='+this.details.id, 'events', false, true).then(data => {
        this.details.mystate = state;
    });
  }

  formatNewsDate(date: any) {
      return moment(date).format('DD.MM.YYYY');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EventsDetailsPage');
  }

  openNews(news: any) {
      if(news.type == 'rss') {
          this.iab.create(news.link, '_blank');
      } else if(news.type == 'own') {
          this.navCtrl.push(NewsReadPage, {news: news});
      }
  }

    openPDF(document_name,event_id, fileUrl){
        const fileTransfer: FileTransferObject = this.transfer.create();
        console.log(this.pdf_path + fileUrl);
        console.log(this.file.dataDirectory + 'events-'+event_id+'.pdf');

        this.loadingProvider.show();
        fileTransfer.download(this.pdf_path + fileUrl, this.file.dataDirectory + 'events-'+event_id+'.pdf').then((entry) => {
            this.loadingProvider.hide();
            this.fileOpener.open(entry.toURL(), 'application/pdf')
                .then(() => console.log('File is opened'))
                .catch(e => console.log('Error opening file', e));
        }, (error) => {
            // handle error
        });
    }


    openWebsite(link: string) {
        this.iab.create(link, '_blank');
    }

}



// WEBPACK FOOTER //
// ./src/pages/events-details/events-details.ts